import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

function Button({ title, type, className, disabled, loading, handleClick }) {
  const { buttonColor } = useSelector((state) => state.theme);
  return (
    <div>
      <button
        type={type}
        className={className}
        disabled={disabled || loading}
        onClick={handleClick}
        style={{
          background: buttonColor,
          border: 0,
          padding: "10px 30px",
          color: "white",
          borderRadius: 10,
        }}
      >
        {title}
      </button>
    </div>
  );
}

Button.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  handleClick: PropTypes.func,
};

Button.defaultProps = {
  title: "Button",
  type: "submit",
  className: "btn btn-primary",
  disabled: false,
  loading: false,
  handleClick: undefined,
};

export default Button;
